var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mdTabs, mdTab, mdButton, mdDialogActions, mdContent, mdIcon, } from 'vue-material';
var CompProps = Vue.extend({
    props: {
        slogan: String
    }
});
var ShooterFrame = /** @class */ (function (_super) {
    __extends(ShooterFrame, _super);
    function ShooterFrame() {
        var _this = _super.call(this) || this;
        _this.styleObject = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            padding: '10px',
            height: '6vh',
            overflowY: 'scroll'
        };
        setTimeout(function () {
            // this.styleObject.height = '100hv'
        }, 10000);
        return _this;
    }
    ShooterFrame.prototype.data = function () {
        return {
            subpage: '1'
        };
    };
    ShooterFrame.prototype.hideMe = function () {
        this.$root.$children[0].showAboutsAndShooterFrame();
        // this.styleObject.display = 'none'
        this.styleObject.height = '6vh';
    };
    ShooterFrame.prototype.showMe = function () {
        this.$root.$children[0].showShooterFrame();
        this.styleObject.height = '100vh';
    };
    ShooterFrame.prototype.destroyMe = function () {
        this.$root.$children[0].showAboutComponent();
    };
    ShooterFrame = __decorate([
        Component({
            components: {
                mdButton: mdButton,
                mdTabs: mdTabs,
                mdTab: mdTab,
                mdDialogActions: mdDialogActions,
                mdContent: mdContent,
                mdIcon: mdIcon
            }
        }),
        Component
    ], ShooterFrame);
    return ShooterFrame;
}(CompProps));
export default ShooterFrame;
